import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { Formik } from "formik";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { TextField, Button } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import './Login.css';
import axios from "axios";
import SweetAlert from 'react-bootstrap-sweetalert';
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import asyncValidate from '../home/asyncValidate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Footer from "./../../../_metronic/layout/footer/Footer";
import { Helmet } from 'react-helmet'

library.add(fas)

const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { asyncValidating, touched, error }
}) => (
    <div className="formgroup">
      <label className="custom-label"></label>
      <div className={asyncValidating ? 'async-validating' : ''}>
        <input {...input} type={type} placeholder={label} disabled={disabled} className="form-control" />
        {touched && error && <span className="error-msg">{error}</span>}
      </div>
    </div>
  )
const renderCheckboxField = ({
  input,
  label,
  type,
  id,
  meta: { asyncValidating, touched, error }
}) => (
    <div className="formgroup render-checkbox">
      <div className={asyncValidating ? 'async-validating form-inline' : 'form-inline'}>
        <input {...input} type={type} id={id} placeholder={label} className="form-control" />
        <label className="custom-label ml-2" htmlFor={id}>{label}</label>
      </div>
    </div>
  )

const validate = values => {
  const errors = {}
  const requiredFields = [
    'email',
    'password',
  ]
  requiredFields.forEach(field => {
    if(!values[field] && field =='email')
        errors[field] ='Please enter email'
    else if(!values[field] && field =='password')
        errors[field] ='Please enter password'
    else if (!values[field]) {
      errors[field] = 'This field is required'
    }
  })
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Please enter valid email address'
  }
  return errors
}

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [sweetOpenError, setSweetOpenError] = useState(false);
  const [messageToDisplay, setMessageToDisplay] = useState('');
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "5px"
  });

  useEffect(() => {
    // localStorage.clear();
  });

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem", width: "95px" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "5px", width: "65px" });
  };

  const login = async (email, password) => {
    localStorage.setItem("profileData", JSON.stringify({ userEmail: "", userName: "" }));
    const formData = {
      "Email": email,
      "Password": password
    };
    const options = {
      headers: {
        'content-type': 'application/json',
      }
    };
    return await axios.post(`${process.env.REACT_APP_API_URL}api/user/login`, formData, options);
  };

  const handleError = async () => {
    setMessageToDisplay('');
    setSweetOpenError(false);
  };

  return (
    <>
      <Helmet>
        <title>Login | Scorecard</title>
      </Helmet>
      <div className="kt-login__body log-in">
        <div className="kt-login__form">
          <div className="m-login__logo">
            <center>
              <a href="#">
                <img src="/images/referral-new-logo.png" />
              </a>
            </center>
          </div>
          <div>
            <div className="login-header p-0 pl-3">
              <FontAwesomeIcon icon={["fas", "lock"]} color="white" />
              <h4 className="py-3 pl-2 bg-dark text-white text-left mb-0 rounded-2 d-inline-block align-items-center rounded-top rounded-right">Login</h4>
            </div>
              <Formik
                initialValues={{
                  email: "",
                  password: ""
                }}
                validate={values => {
                  const errors = {};
                  if (!values.email) {
                    errors.email = intl.formatMessage({
                      id: "AUTH.VALIDATION.REQUIRED_FIELD"
                    });
                  } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                  ) {
                    errors.email = intl.formatMessage({
                      id: "AUTH.VALIDATION.INVALID_FIELD"
                    });
                  }

                  if (!values.password) {
                    errors.password = intl.formatMessage({
                      id: "AUTH.VALIDATION.REQUIRED_FIELD"
                    });
                  }

                  return errors;
                }}

                onSubmit={(values, { setStatus, setSubmitting }) => {
                  enableLoading();
                  login(values.email, values.password).then((response) => {
                    disableLoading();
                    if (response.data.success) {
                      props.login(response.data);
                    } else {
                      setSubmitting(false);
                      if (response.data.success == false) {
                        setSweetOpenError(true);
                        setMessageToDisplay(response.data.message)
                      } else {
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                      }
                    }
                  }).catch(() => {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_LOGIN"
                      })
                    );
                  });
                }}
              >
                {({
                  values,
                  status,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  isValid,dirty
                }) => (
                    <form
                      autoComplete="off"
                      className="kt-form"
                      onSubmit={handleSubmit}
                    >
                      {status ? (
                        <div role="alert" className="alert alert-danger">
                          <div className="alert-text">{status}</div>
                        </div>
                      ) : (
                          <></>
                        )}
                        <div className="login-body">
                      <div className="formgroup email-field">
                        <Field
                          type="email"
                          margin="normal"
                          name="email"
                          label="Email"kt-login__btn-primary
                          component={renderField}
                          value={values.email}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="formgroup password-input" style={{ marginTop: "-10px" }}>
                        <Field
                          type="password"
                          margin="normal"
                          name="password"
                          label="Password"
                          component={renderField}
                          value={values.password}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="formgroup form-inline justify-content-end">
                        {/* <Field
                          type="checkbox"
                          margin="normal"
                          name="rememberMe"
                          id="rememberMe"
                          label="Remember me"
                          component={renderCheckboxField}
                          onChange={handleChange}
                        /> */}
                        <div className="formgroup">
                            <Link
                              id="m_login_forget_password" className="m-link"
                              to="/auth/forgot-password">
                              Forgot Password?
                          </Link>
                        </div>
                      </div>
                      </div>
                      <div className="login-footer p-3">
                        <button
                          id="kt_login_signin_submit"
                          type="submit"
                          className={`btn btn-primary btn-elevate kt-login__btn-primary font-weight-bold ${clsx(
                            {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            disabled={!isValid || !dirty}
                            style={loadingButtonStyle}
                            >
                          LOGIN
                          </button>
                      </div>
                    </form>
                  )}
              </Formik>
            </div>
        </div>
      </div>
      <Footer/>
      {sweetOpenError && (
        <SweetAlert
          error
          confirmBtnText="Ok"
          confirmBtnBsStyle="danger"
          title={messageToDisplay}
          onConfirm={handleError.bind(this)}
        >
        </SweetAlert>
      )}
    </>
  );
}

Login = reduxForm({
  form: 'Login',
  validate,
  enableReinitialize: true,
  destroyOnUnmount: true
})(Login);

export default injectIntl(
  connect(
    null,
    auth.actions
  )(Login)
);
